import React, { type FC } from "react";
import { Box, type BoxProps } from "@mui/material";
import { motion } from "framer-motion";

type SkeletonProps = BoxProps & {
  width?: number | string;
  height?: number | string;
};

export const TextInputSkeleton: FC<SkeletonProps> = ({
  width = "100%",
  height = 32,
  sx,
  ...props
}: SkeletonProps) => {
  return (
    <Box
      component={motion.div}
      sx={{
        fontSize: "1rem",
        paddingX: 4,
        paddingY: 1,
        borderRadius: 1,
        width,
        height,
        bgcolor: "grey.300",
        ...sx,
      }}
      animate={{ opacity: [0.45, 1, 0.45] }}
      transition={{
        duration: 1.2,
        repeat: Infinity,
        ease: "easeInOut",
      }}
      {...props}
    />
  );
};